export enum HtmlControlType {
  List = 0,
  Dropdown = 1,
  Textbox = 2
}
